import { markInputRule, mergeAttributes } from '@tiptap/core';
import Italic, { underscoreInputRegex } from '@tiptap/extension-italic';

const CustomItalic = Italic.extend({
  // Override renderHTML to use <i> instead of <em>
  renderHTML({ HTMLAttributes }) {
    return ['i', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  // Override addInputRules to keep only the underscore rule
  addInputRules() {
    return [
      markInputRule({
        find: underscoreInputRegex, // Keep the _italic_ rule
        type: this.type,
      }),
    ];
  },
});

export default CustomItalic;
